import { ShiftsDeleteSchema, ShiftsDeleteSchemaType } from './schema'

const Form = () => {
  const defaultValues: ShiftsDeleteSchemaType = {
    startAt: new Date(),
    endAt: new Date(),
    employeeId: null,
    employeeSelection: {
      type: 'manual',
      ids: [],
    },
  }

  return {
    defaultValues,
    schema: ShiftsDeleteSchema(),
  }
}

export {Form}
